import React, { useEffect, useState, lazy, createElement } from 'react';
const CTASection = () => {
  // Load Calendly script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  // Load Typeform script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <section className="py-20 bg-blue-50" id="book-demo" data-id="element-104">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105">
        <div className="text-center mb-12" data-id="element-106">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl" data-id="element-107">
            Ready to Elevate Your Spa Experience?
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-108">
            Schedule a free demo or get a custom quote for your spa
          </p>
        </div>
        {/* Tumbler Giveaway Showcase - Consolidated and Prominent */}
        <div className="max-w-4xl mx-auto mb-12 bg-white rounded-xl overflow-hidden shadow-lg border-2 border-teal-300" data-id="element-109">
          <div className="flex flex-col md:flex-row items-center" data-id="element-110">
            <div className="md:w-1/3 p-6 flex justify-center" data-id="element-111">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fhizc7eBkoB2exEg5vSUKB/Gemini_Generated_Image_b2ko4vb2ko4vb2ko.png" alt="SmartSoda Tumbler Giveaway - Free premium tumbler with demo booking" className="w-full h-auto max-w-[180px]" width="180" height="240" loading="lazy" decoding="async" data-id="element-112" />
            </div>
            <div className="md:w-2/3 p-6 flex flex-col justify-center bg-gradient-to-r from-white to-teal-50" data-id="element-113">
              <div className="inline-block px-4 py-1 bg-teal-100 border-2 border-teal-300 rounded-full text-teal-800 text-sm font-bold mb-4" data-id="element-114">
                EXCLUSIVE SPA OFFER
              </div>
              <h3 className="text-2xl font-bold text-navy-950 mb-3" data-id="element-115">
                FREE Premium Tumblers for Your Spa!
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-116">
                Book a demo today and receive our stylish SmartSoda tumbler as
                our gift to you. Plus, get 50 FREE branded tumblers for your
                guests when you sign up for our service!
              </p>
              <p className="text-sm text-gray-500 italic" data-id="element-117">
                Our premium insulated tumblers can be custom-branded with your
                spa logo and keep wellness beverages at the perfect temperature
                for hours.
              </p>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-118">
          {/* Calendly Widget */}
          <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-119">
            <div className="flex items-center justify-between mb-4" data-id="element-120">
              <h3 className="text-xl font-semibold text-gray-900" data-id="element-121">
                Book a Free Demo
              </h3>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-122">
                FREE Tumblers Included
              </span>
            </div>
            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6" data-id="element-123">
              <div className="flex" data-id="element-124">
                <div className="flex-shrink-0" data-id="element-125">
                  <svg className="h-5 w-5 text-blue-500" viewBox="0 0 20 20" fill="currentColor" data-id="element-126">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" data-id="element-127" />
                  </svg>
                </div>
                <div className="ml-3" data-id="element-128">
                  <p className="text-sm text-blue-800" data-id="element-129">
                    Schedule a 30-minute demo to see how SmartSoda can transform
                    your spa beverage experience and create a new revenue
                    stream.
                  </p>
                </div>
              </div>
            </div>
            {/* Calendly inline widget */}
            <div className="calendly-inline-widget" data-url="https://calendly.com/-smartsoda/discoverycall?hide_event_type_details=1" style={{
            minWidth: '320px',
            height: '700px'
          }} data-id="element-130"></div>
          </div>
          {/* Typeform Widget */}
          <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-131">
            <div className="flex items-center justify-between mb-4" data-id="element-132">
              <h3 className="text-xl font-semibold text-gray-900" data-id="element-133">
                Get a Custom Spa Quote
              </h3>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-134">
                FREE Tumblers Included
              </span>
            </div>
            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6" data-id="element-135">
              <div className="flex" data-id="element-136">
                <div className="flex-shrink-0" data-id="element-137">
                  <svg className="h-5 w-5 text-blue-500" viewBox="0 0 20 20" fill="currentColor" data-id="element-138">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" data-id="element-139" />
                  </svg>
                </div>
                <div className="ml-3" data-id="element-140">
                  <p className="text-sm text-blue-800" data-id="element-141">
                    Tell us about your spa needs and we'll prepare a customized
                    beverage program proposal within 24 hours.
                  </p>
                </div>
              </div>
            </div>
            {/* Typeform Embed */}
            <div data-tf-live="01K5DCNH8GKNSA8GDZ9GD0RHEG" style={{
            height: '650px',
            width: '100%'
          }} data-id="element-142"></div>
          </div>
        </div>
      </div>
    </section>;
};
export default CTASection;